import { Types } from "@grandvisionhq/graphql";
const recoverableErrorCodes = [
  Types.ValidationCode.IS_IN_STOCK,
  Types.ValidationCode.PRODUCTS_ARE_NOT_EXCLUDED_FROM_CHECKOUT
];
const hasCartErrors = (validationErrors) => {
  const uniqueLineItemErrors = [
    ...new Set(
      Object.entries(validationErrors || {}).flatMap(([, errorCode]) => {
        return errorCode.filter((item) => recoverableErrorCodes.includes(item));
      })
    )
  ];
  return {
    recoverableErrors: Boolean(uniqueLineItemErrors.length)
  };
};
export {
  hasCartErrors
};
//# sourceMappingURL=has-cart-errors.js.map
